<template>
  <div v-bind="$attrs">
    <div
      class="flex rounded-md shadow-sm"
      :class="{
        'bg-kintz-primary-1': kintzApp,
      }"
    >
      <span
        v-if="!isIcon && showIcon"
        class="inline-flex items-center rounded-l-md border border-r-0 px-3 sm:text-sm"
        :class="{
          'border-gray-300 text-gray-500': !kintzApp,
          'border-kintz-primary-1 text-kintz-primary-4': kintzApp,
        }"
        >{{ title }}</span
      >
      <div
        v-if="isIcon && showIcon"
        class="inline-flex items-center rounded-l-md border border-r-0 px-3 sm:text-sm"
        :class="{
          'border-gray-300 text-gray-500': !kintzApp,
          'border-kintz-primary-3 bg-kintz-primary-3 text-kintz-primary-4':
            kintzApp,
        }"
      >
        <component :is="icon" class="w-4" />
      </div>

      <el-select
        v-model="selected"
        :placeholder="placeholder"
        :size="size"
        @change="handleChange"
        :clearable="clearable"
        class="block w-full min-w-0 flex-1 rounded-none rounded-r-md border-0 ring-1 ring-inset sm:text-sm sm:leading-6"
        :class="{
          'text-gray-900 ring-gray-300 placeholder:text-gray-400': !kintzApp,
        }"
      >
        <el-option
          v-for="item in options"
          :key="item[value]"
          :label="item[label]"
          :value="item[value]"
        />
      </el-select>
    </div>
  </div>
</template>
<script setup>
import { computed, defineProps, defineEmits } from "vue";
import { ElSelect, ElOption } from "element-plus";

const props = defineProps({
  size: {
    type: String,
    default: "large",
  },
  options: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: "name",
  },
  value: {
    type: String,
    default: "value",
  },
  placeholder: {
    type: String,
    default: "Select value",
  },
  modelValue: null,
  isIcon: {
    type: Boolean,
    default: false,
  },
  icon: null,
  title: {
    type: String,
    default: "Title",
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
  kintzApp: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "change"]);
const size = computed(() => props.size);
const options = computed(() => props.options);
const label = computed(() => props.label);
const value = computed(() => props.value);
const placeholder = computed(() => props.placeholder);
const icon = computed(() => props.icon);
const isIcon = computed(() => props.isIcon);
const title = computed(() => props.title);
const clearable = computed(() => props.clearable);
const showIcon = computed(() => props.showIcon);
const kintzApp = computed(() => props.kintzApp);
const selected = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const handleChange = (event) => {
  emit("change", event);
};
</script>
